module.exports = __webpack_public_path__ + "fonts/fontello.7a90f83c.ttf";